import React, { useState } from "react";
import { FaPhone, FaFax, FaEnvelope, FaCheckCircle } from "react-icons/fa";
import contentConfig from "../content.config.json";
import "../Styles/Contact.css";

const Contact = () => {
  const { title, subtitle, description, info, form, formTitle, successMessage } = contentConfig.contact;
  
  const [formData, setFormData] = useState(
    form.fields.reduce((acc, field) => {
      acc[field.name] = "";
      return acc;
    }, {})
  );

  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const API_URL = process.env.REACT_APP_API_URL || "/api/send-email";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setShowPopup(true);
        setFormData(
          form.fields.reduce((acc, field) => {
            acc[field.name] = "";
            return acc;
          }, {})
        );
      } else {
        const errorData = await response.json();
        setError(errorData.error || "Something went wrong.");
      }
    } catch (error) {
      setError("Network error. Please check your connection.");
    } finally {
      setLoading(false);
    }
  };

  const iconMap = {
    phone: FaPhone,
    fax: FaFax,
    envelope: FaEnvelope,
  };

  return (
    <div className="contact-page">
      <div className="banner">
        <div className="banner-overlay">{title}</div>
      </div>

      <div className="contact-container">
        <div className="contact-grid">
          <div className="contact-info-section">
            <h3 className="contact-info-title">{subtitle}</h3>
            <p className="contact-info-description">{description}</p>
            
            <div className="contact-info-cards">
              {info.map((item, index) => {
                const Icon = iconMap[item.icon];
                const content = item.link ? (
                  <a href={item.link} className="contact-info-link">
                    {item.value}
                  </a>
                ) : (
                  <span>{item.value}</span>
                );

                return (
                  <div key={index} className="contact-info-card">
                    <div className="contact-info-icon">
                      <Icon />
                    </div>
                    <div className="contact-info-content">
                      <p className="contact-info-label">{item.label}</p>
                      {content}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="contact-form-section">
            <h3 className="contact-form-title">{formTitle}</h3>
            <form onSubmit={handleSubmit} className="contact-form">
              {form.fields.map((field) => {
                if (field.type === "textarea") {
                  return (
                    <div key={field.name} className="form-field">
                      <textarea
                        name={field.name}
                        placeholder={field.placeholder}
                        value={formData[field.name]}
                        onChange={handleChange}
                        required={field.required}
                        rows="6"
                      ></textarea>
                    </div>
                  );
                }

                return (
                  <div key={field.name} className="form-field">
                    <input
                      type={field.type}
                      name={field.name}
                      placeholder={field.placeholder}
                      value={formData[field.name]}
                      onChange={handleChange}
                      required={field.required}
                    />
                  </div>
                );
              })}

              {error && <p className="error-message">{error}</p>}

              <button type="submit" className="submit-button" disabled={loading}>
                {loading ? "Sending..." : form.submitText}
              </button>
            </form>
          </div>
        </div>
      </div>

      {showPopup && (
        <div className="modal-overlay" onClick={() => setShowPopup(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-icon">
              <FaCheckCircle />
            </div>
            <h3>{successMessage.title}</h3>
            <p>{successMessage.message}</p>
            <button onClick={() => setShowPopup(false)} className="modal-button">
              Close
            </button>
          </div>
        </div>
      )}

      {loading && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="loading-spinner"></div>
            <p>Sending your message...</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Contact;